/**
 * @author: Angel Labrada Massó
 * @version: v0.0.1
 * @date:
 */
import React, { memo } from 'react';

const SimpleBanner = () => {
  return (
    <svg width='27' height='15' viewBox='0 0 27 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect y='2.54883' width='26.1472' height='7.40015' rx='1.54361' fill='white' />
      <rect x='8.23438' y='11.0312' width='9.67716' height='1.07524' rx='0.53762' fill='white' />
      <rect x='7.94922' y='11.0527' width='4.30096' height='1.07524' rx='0.53762' fill='#D4CFCF' />
    </svg>
  );
};

export default memo(SimpleBanner);
